import { addMessages } from '@hana/i18n';

// Khoá chuỗi creq.* — mã nghiệp vụ không dịch.
addMessages('vi', {
  'creq.1': "In tổng hợp tháng",
  'creq.2': "Đợt chi · phiếu chi đối tác →",
});
addMessages('en', {
  'creq.1': "Print monthly summary",
  'creq.2': "Payment batch · partner vouchers →",
});
